import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from "../../../models/utilities/filter-bar";
import { ListColumn, SelectedSort } from "../../../models/utilities/list-header";
import { PageData } from "../../../models/utilities/paged-request";
import { ApiEndpoints } from "../../../utils/app-constants";
import { AppUtils } from "../../../utils/app-utils";
import { EngineeringReviewReasonMetadata } from "./engineering-review-list";

export class EngineeringReviewSearchFilters implements IFilterBar {

    public paginationInfo: PageData = new PageData(10000);
    public baseUrl: string = ApiEndpoints.ORDERING_ENGINEERING_REVIEW;
    public filters: FilterGroup[] = [];
    public appliedFilters: AppliedFilterBarOpt[] = [];
    public requiredFilters: AppliedFilterBarOpt[] = [];
    public columns: ListColumn[];
    public selectedSort: SelectedSort;

    constructor() {

        // Set our table columns
        this.columns = [
            new ListColumn('Order Id', 'orderId', false),
            new ListColumn('Description', 'description', false),
            new ListColumn('Cutoff', 'cutoffDate', false),
            new ListColumn('Type', 'reason', false),
        ];

        // Create our Filter Groups
        const byCutoff = this.buildCutoff();
        const byOrder = this.buildOrder();
        const byReason = this.buildReason();

        this.filters.push(
            byCutoff, byOrder, byReason
        );

    }

    // #region Group Builders
    private buildCutoff() {
        const byDate = new FilterGroup('Cutoff', 'dateplus', 'maxCutoff');
        const opt1 = new FilterBarInputOpt('Cutoff', {
            selectedDate: {
                qsValue: new Date(),
                qsName: 'maxCutoff'
            },
            checkboxValue: {
                qsValue: false,
                qsName: 'matchDayOfWeek'
            }
        });

        byDate.opts = [opt1];

        return byDate;
    }

    private buildOrder() {
        const byOrderId = new FilterGroup('Order ID', 'text', 'orderId');
        const opt1 = new FilterBarInputOpt('Order ID', '');

        byOrderId.opts = [opt1];

        return byOrderId;
    }

    private buildReason()
    {
        const byReason = new FilterGroup('Reason', 'checkboxes', 'reasons');
        // Only the engineering reasons are offered: the wind load, customer service and address reviews are not
        // engineering reasons, and have pages of their own
        byReason.opts = AppUtils.enumMetadataToFilters(EngineeringReviewReasonMetadata);

        return byReason;
    }

    // #endregion

}
